CollectionWithHelpers = require 'app/scripts/models/collections/internal/collection-with-helpers'
{ Membership } = require 'app/scripts/models/Membership'

class MembershipList extends CollectionWithHelpers
  model: Membership

  initialize: ->
    @memberIndex = {}

    @listenTo @, 'add', (model) =>
      @memberIndex[model.get('idMember')] = model

    @listenTo @, 'remove', (model) =>
      delete @memberIndex[model.get('idMember')]

    @listenTo @, 'reset', =>
      @memberIndex = {}
      for membership in @models
        @memberIndex[membership.get('idMember')] = membership

  getMember: (member) ->
    idMember = member?.id ? member
    @memberIndex[idMember]

module.exports = MembershipList
